/* global wpApiSettings */
import { createAsyncThunk } from "@reduxjs/toolkit";
import { wpBase, mcBase } from "../api/base";
import axios from "axios";

// WP - FETCH CAR DETALS
const fetchWpCarDetails = createAsyncThunk("carsDetails/fetch", async (id) => {
  const response = await wpBase.get(`/wp-json/wp/v2/hp_listing/${id}`);
  return response;
});

// WP - FETCH VENDORS
const fetchWpVendors = createAsyncThunk("vendors/fetch", async (vendorId) => {
  const response = await wpBase.get(`/wp-json/wp/v2/hp_vendor/${vendorId}`);
  return response;
});

/**********THIRD PARTY API**********/

// MC - FETCH CAR DETALS / VENDORS
const fetchMcCarDetails = createAsyncThunk(
  "mcCarsDetails/fetch",
  async ({ id, type }) => {
    const response = await mcBase.get(
      `/v2/listing/${type}/${id}?api_key=${process.env.REACT_APP_MC_API_KEY}`
    );
    return response;
  }
);

// REAL ESTATE - FETCH CAR DETALS / VENDORS
const fetchRealtyHouseDetails = createAsyncThunk(
  "realEstateDetails/fetch",
  async ({ id, type }) => {
    const url = `${wpApiSettings.root}fz-housing-details-api/v1/data?houseId=${id}`;
    try {
      // Fetch data from the custom WordPress API endpoint
      const response = await axios.get(url, {
        headers: {
          'X-WP-Nonce': wpApiSettings.nonce, // Include nonce for security
        },
      });

      // Return the response data
      return response;
    } catch (error) {
      // Handle any errors during the request
      console.error('Error fetching data from API:', error);
      throw error;
    }

  }
);
export { fetchWpCarDetails, fetchMcCarDetails, fetchWpVendors, fetchRealtyHouseDetails };
